import * as React from "react";
import Button from "@mui/material/Button";
import DialogTitle from "@mui/material/DialogTitle";
import {Stack, TextField, Typography} from "@mui/material";
import {
  BootstrapDialog,
  StyledTextTimeStamp,
  StyledTextCoordinatorName,
  StyledDialogContent,
  StyledDialogActions,
} from "./DialogModel.styles";
import { useNavigate } from "react-router-dom";
import { associateReadingType } from "helpers/variables";
import { useContext, useState } from "react";
import { GlobalContext } from "context/Provider";
import API from "api";
import Session from "../../../helpers/session";

export type CustomDialogProps = {
  coordinatorName: string;
  coordinatorId: string;
  patientName: string;
  patientId: string;
  readingId?: string;
  date: string;
  content: string;
  isNote: boolean;
  open?: boolean;
  onClose?: () => void;
};
export interface DialogTitleProps {
  id: string;
  children?: React.ReactNode;
  onClose: () => void;
}
function BootstrapDialogTitle(props: DialogTitleProps) {
  const { children, onClose, ...other } = props;
  return (
    <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
      {children}
    </DialogTitle>
  );
}
const CustomizedDialogs: React.FC<CustomDialogProps> = ({
  coordinatorName,
  coordinatorId,
  patientName,
  patientId,
  readingId,
  date,
  content,
  isNote,
  open,
  onClose
}) => {
  const { readingsDispatch } = useContext(GlobalContext);
  const navigate = useNavigate();
  const [readingMissing, setReadingMissing] = useState(false);

  const showReadingMissing = () => {
    setReadingMissing(true);
    setTimeout(() => {
      setReadingMissing(false);
    }, 5000);
  };

  const handleNavigateToReading = () => {
    if (!readingId) return;
    API.kore.readings
      .getSingleReading(
        readingId || "",
        Session.crackCookieToken("coordinator")
      )
      .then((reading) => {
        if (!reading || !reading.id) {
          showReadingMissing();
          return;
        }
        readingsDispatch({ type: "UPDATE_READING", payload: reading });
        navigate(
          `/patient/history/${associateReadingType(reading.type || "kk")
            .toLowerCase()
            .replace(" ", "")}/${reading.id}/${reading.memberId}`
        );
      }).catch((err) => {
        showReadingMissing();
      });
  };

  return (
    <BootstrapDialog
      onClose={onClose}
      aria-labelledby="customized-dialog-title"
      open={open ?? false}
    >
      <BootstrapDialogTitle
        id="customized-dialog-title"
        onClose={onClose ?? (() => {})}
      >
        {patientName}
      </BootstrapDialogTitle>
      <StyledDialogContent dividers>
        <Stack direction="row">
          <b>Coordinator Name:</b>
          <StyledTextCoordinatorName>{coordinatorName}</StyledTextCoordinatorName>
        </Stack>
        <Stack direction="row">
          <b>Time:</b>
          <StyledTextTimeStamp>{date}</StyledTextTimeStamp>
        </Stack>
        <Stack>
          <h3>Note:</h3>
          <TextField
            disabled
            value={content}
            multiline
            variant="outlined"
          />
        </Stack>
        {readingId && (
          <>
            {readingMissing && (
              <Typography color="error" variant="body2" sx={{ mb: 1 }}>
                This reading is no longer available.
              </Typography>
            )}
            <Button onClick={handleNavigateToReading}>Go To Reading</Button>
          </>
        )}
      </StyledDialogContent>
      <StyledDialogActions>
        <Button autoFocus onClick={onClose}>
          Done
        </Button>
      </StyledDialogActions>
    </BootstrapDialog>
  );

};
export default CustomizedDialogs;
